export class StringUtils {
    static capitalizeName(name: string): string {
        return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
    }
}
